import axios from 'axios';

import {
  ResponseObj,
  InternacaoNovaFormData,
  InternacaoEditFormData,
  InternacaoConfirmarAltaFormData,
  InternacaoPreverAltaFormData,
  InternacaoSuspenderAltaFormData,
  InternacaoIniciarFormData,
  InternacoesPaginatedData,
  InternacaoCancelarFormData,
} from '../../../back/src/types';
import { Internacao } from '../../../back/src/entity/Internacao';

const buscaInternacao = async (internacaoId: number): Promise<ResponseObj<Internacao>> => {
  const res = await axios.get<ResponseObj<Internacao>>(`internacoes/${internacaoId}`);
  return res.data;
};

const buscaInternacoesAtivas = async (): Promise<ResponseObj<Internacao[]>> => {
  const res = await axios.get<ResponseObj<Internacao[]>>('internacoes/ativas');
  return res.data;
};

const buscaInternacoesFinalizadas = async (
  queryObj: Object = {},
): Promise<ResponseObj<InternacoesPaginatedData>> => {
  const res = await axios.get<ResponseObj<InternacoesPaginatedData>>('internacoes/finalizadas', {
    params: queryObj,
  });
  return res.data;
};

const criaInternacao = async (
  formData: InternacaoNovaFormData,
): Promise<ResponseObj<Internacao>> => {
  const res = await axios.post<ResponseObj<Internacao>>('internacoes', formData);
  return res.data;
};

const atualizaInternacao = async (
  internacaoId: number, formData: InternacaoEditFormData,
): Promise<ResponseObj<Internacao>> => {
  const res = await axios.put<ResponseObj<Internacao>>(`internacoes/${internacaoId}`, formData);
  return res.data;
};

const iniciarInternacao = async (
  internacaoId: number, formData: InternacaoIniciarFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.put<ResponseObj<null>>(`internacoes/${internacaoId}/iniciar`, formData);
  return res.data;
};

const preverAltaInternacao = async (
  internacaoId: number, formData: InternacaoPreverAltaFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.put<ResponseObj<null>>(`internacoes/${internacaoId}/prever_alta`, formData);
  return res.data;
};

const suspenderAltaInternacao = async (
  internacaoId: number, formData: InternacaoSuspenderAltaFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.put<ResponseObj<null>>(`internacoes/${internacaoId}/suspender_alta`, formData);
  return res.data;
};

const confirmarAltaInternacao = async (
  internacaoId: number, formData: InternacaoConfirmarAltaFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.put<ResponseObj<null>>(`internacoes/${internacaoId}/confirmar_alta`, formData);
  return res.data;
};

const cancelarInternacao = async (
  internacaoId: number, formData: InternacaoCancelarFormData,
): Promise<ResponseObj<null>> => {
  const res = await axios.put<ResponseObj<null>>(`internacoes/${internacaoId}/cancelar`, formData);
  return res.data;
};

export default {
  buscaInternacao,
  buscaInternacoesAtivas,
  buscaInternacoesFinalizadas,
  criaInternacao,
  atualizaInternacao,
  iniciarInternacao,
  preverAltaInternacao,
  suspenderAltaInternacao,
  confirmarAltaInternacao,
  cancelarInternacao,
};
